import { useQuery } from '@tanstack/react-query';
import { schoolClassificationApi } from '@/features/reports/api';
import { ApiError } from '@/shared/api';

const UUID_PREFIX_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-/i;

export function isDashboardSchoolId(id: string | undefined): boolean {
  return Boolean(id?.trim() && UUID_PREFIX_RE.test(id.trim()));
}

export const schoolClassificationDashboardQueryKeys = {
  all: ['school-classification', 'dashboard'] as const,
  detail: (schoolId: string, year: number) =>
    [...schoolClassificationDashboardQueryKeys.all, schoolId, year] as const,
};

export function useSchoolClassificationDashboardQuery(
  schoolId: string | undefined,
  year: string | undefined,
  options?: { classificationWorkflowReady?: boolean }
) {
  const y = year && /^\d+$/.test(year.trim()) ? parseInt(year.trim(), 10) : NaN;
  const wf = options?.classificationWorkflowReady;
  const enabled =
    (wf !== false) && isDashboardSchoolId(schoolId) && Number.isFinite(y) && y > 0;

  return useQuery({
    queryKey: schoolClassificationDashboardQueryKeys.detail(schoolId ?? '', y || 0),
    queryFn: () => schoolClassificationApi.getSchoolClassificationForDashboard(schoolId!, y),
    enabled,
    retry: false,
  });
}

export function schoolClassificationDashboardErrorMessage(err: unknown): string {
  return err instanceof ApiError ? ApiError.getUserMessage(err) ?? err.message : 'Could not load dashboard.';
}
